export default __webpack_public_path__ + "static/media/Risk alert.f5e5dc06.svg";